import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { MccForm } from 'features/cris/mccs/mcc-form';
import { MccSearch } from 'features/cris/mccs/mcc-search';

export const MccRouter: React.FunctionComponent = () => (
    <Switch>
        <Route exact path='/cris/mccs'>
            <MccSearch />
        </Route>
        <Route exact path='/cris/mccs/:id'>
            <MccForm />
        </Route>
    </Switch>
);
